import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  CLEAR_CARGO_PRICE,
  FLAG_PARCEL_ACTIVITY,
  POST_CARGO_PRICE,
  CLEAR_CARGO_PRICES,
  FLAG_GETTING_PARCELS,
  GET_PARCELS,
  CLEAR_PARCELS,
  GET_PARCEL,
  CLEAR_PARCEL,
  PRINT_CARGO_VOUCHER_ON_MOUNT,
  FLAG_GETTING_INCOMES_PARCELS,
  GET_INCOMES_PARCELS,
  FLAG_GETTING_OTHER_INCOMES_PARCELS,
  GET_OTHER_INCOMES_PARCELS,
  CLEAR_INCOMES_PARCELS,
  CLEAR_OTHER_INCOMES_PARCELS,
  CLEAR_CARGO_PRICE_BAGGAGE,
  FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY,
  POST_CARGO_PRICE_BAGGAGE,
  PRINT_CARGO_VOUCHER_STICKER,
} from '../types/cargo';
import {
  CARGO_PRICE_ENDPOINT,
  PARCEL_ENDPOINT,
  POST_PARCEL_COMMENT_ENDPOINT,
  generatePostParcelRefund,
  generatePostParcelChangeCode,
  generatePutParcelPay,
  generateSalesSessionParcelsEnpoint,
  generatePostCreditNoteParcel,
  generatePostSendParcelByEmailEndpoint,
  generateGetParcelBySeriesAndCorrelative,
  generatePostParcelVoid,
  generateSalesSessionOtherIncomesParcelsEnpoint,
  generatePostParcelVoidPayment,
  generatePostParcelVoidPaymentAuthorization,
  generatePostParcelChangeConsigneeCustomer,
  generatePostParcelRefundV2,
  generateParcelPinPadTransactionsEndpoint,
  generateRegisterParcelPinPadVoidEndpoint,
  PARCEL_ENDPOINT_AUTHORIZATION,
} from '../../config/endpoints';
import {
  DEFAULT_POST_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { handleResponse, isErrorResponse } from '../../utils/error-handlers';
import { CARGO_PATH } from '../../config/paths';

const clearCargoPrices = () => (dispatch) =>
  dispatch({
    type: CLEAR_CARGO_PRICES,
  });

const clearCargoPrice = (index) => (dispatch) =>
  dispatch({
    type: CLEAR_CARGO_PRICE,
    payload: index,
  });

const flagParcelActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_PARCEL_ACTIVITY,
    payload: flag,
  });

const flagGettingParcels = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_PARCELS,
    payload: flag,
  });

const flagGettingIncomesParcels = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_INCOMES_PARCELS,
    payload: flag,
  });

const flagGettingOtherIncomesParcels = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_OTHER_INCOMES_PARCELS,
    payload: flag,
  });

const clearParcels = () => (dispatch) =>
  dispatch({
    type: CLEAR_PARCELS,
  });

const clearIncomesParcels = () => (dispatch) =>
  dispatch({
    type: CLEAR_INCOMES_PARCELS,
  });

const clearOtherIncomesParcels = () => (dispatch) =>
  dispatch({
    type: CLEAR_OTHER_INCOMES_PARCELS,
  });

const getParcels = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingParcels(true));
    const query = tableFilters;
    const url = `${PARCEL_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const parcels = await response.json();
    dispatch({
      type: GET_PARCELS,
      payload: parcels,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingParcels(false));
  }
};

const getSalesSessionParcels =
  async ({ salesSessionId }, tableFilters) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingIncomesParcels(true));
      const query = {
        ...tableFilters,
        query: [...tableFilters.query, `salesSessionId:${salesSessionId}`],
      };
      const url = `${generateSalesSessionParcelsEnpoint(
        salesSessionId,
      )}?${QueryString.stringify(query)}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const parcels = await response.json();
      dispatch({
        type: GET_INCOMES_PARCELS,
        payload: parcels,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingIncomesParcels(false));
    }
  };

const getSalesSessionOtherIncomesParcels =
  async ({ salesSessionId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingOtherIncomesParcels(true));
      const url = `${generateSalesSessionOtherIncomesParcelsEnpoint(
        salesSessionId,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const parcels = await response.json();
      await dispatch({
        type: GET_OTHER_INCOMES_PARCELS,
        payload: parcels,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingOtherIncomesParcels(false));
    }
  };

const postCargoPrice =
  async (
    indexes,
    {
      sourceLocationId,
      destinationLocationId,
      cargoItemList,
      discountCodeString,
      parcelServiceTypeId,
      businessId,
      customerId,
      hasDelivery,
      postalCode,
      increasedPrice,
      deliveryAddress,
      deliveryLatitude,
      deliveryLongitude,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const payload = {
        sourceLocationId,
        destinationLocationId,
        parcelServiceTypeId,
        cargoItemList,
        businessId,
        discountCodeString,
        customerId,
        hasDelivery,
        postalCode,
        increasedPrice,
        deliveryAddress,
        deliveryLatitude,
        deliveryLongitude,
      };
      const url = CARGO_PRICE_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const prices = await response.json();
      const payloadForDispatch = {
        pricesList: prices.cargoPricingList.map((price, index) => ({
          index: indexes[index],
          price,
        })),
        totalPrice: prices.totalPrice,
        finalPrice: prices.finalPrice,
        corporateCreditAmount: prices.corporateCreditAmount,
        listPrice: prices.listPrice,
        servicePrice: prices.servicePrice,
        deliveryPrice: prices.deliveryPrice,
        discountAmount: prices.discountAmount,
        discountListPrice: prices.discountListPrice,
        netDiscountAmount: prices.netDiscountAmount,
        discountCodeString: prices.discountCodeString,
        yangoPrice: prices.yangoPrice,
      };
      dispatch({
        type: POST_CARGO_PRICE,
        payload: payloadForDispatch,
      });
      return prices;
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const flagPrintCargoVoucher = (flag) => (dispatch) =>
  dispatch({
    type: PRINT_CARGO_VOUCHER_ON_MOUNT,
    payload: flag,
  });

const flagPrintCargo = (flag) => (dispatch) =>
  dispatch({
    type: PRINT_CARGO_VOUCHER_STICKER,
    payload: flag,
  });

const postParcel =
  async (
    {
      voucherTypeId,
      voucherCode,
      sourceCityId,
      sourceLocationId,
      destinationCityId,
      destinationLocationId,
      senderCustomerId,
      consigneeCustomerId,
      secondaryConsigneeCustomerId,
      paymentMethodId,
      comments,
      cargoItemList,
      listPrice,
      salePrice,
      cargoDelivery,
      customerId,
      businessId,
      secretCode,
      attachedDocument,
      discountCodeString,
      netDiscountAmount,
      salesPriceWithDiscount,
      corporateCreditAmount,
      contingencyDocumentSeries,
      contingencyDocumentCode,
      contingencyMotive,
      attachedDocumentList,
      deliveryAddress,
      deliveryDistrictId,
      deliveryPrice,
      deliveryLatitude,
      deliveryLongitude,
      deliveryPostalCode,
      transactionList,
      contingencyAssignmentDocumentDate,
      consigneePhoneNumber,
      discountCodeSubCategoryId,
      discountCodeAuthorizerId,
      increasedPrice,
      uuid,
      yangoDelivery,
      freeOfChargeCategoryId,
      freeOfChargeSubCategoryId,
      freeOfChargeUserId,
      pinPadTransactions,
    },
    authorization = false,
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));

      const payload = {
        voucherTypeId,
        voucherCode,
        sourceCityId,
        sourceLocationId,
        destinationCityId,
        destinationLocationId,
        senderCustomerId,
        consigneeCustomerId,
        secondaryConsigneeCustomerId,
        paymentMethodId,
        comments,
        cargoItemList,
        listPrice,
        salePrice,
        cargoDelivery,
        customerId,
        businessId,
        secretCode,
        attachedDocument,
        discountCodeString,
        netDiscountAmount,
        salesPriceWithDiscount,
        corporateCreditAmount,
        contingencyDocumentSeries,
        contingencyDocumentCode,
        contingencyMotive,
        attachedDocumentList,
        deliveryAddress,
        deliveryDistrictId,
        deliveryPrice,
        deliveryLatitude,
        deliveryLongitude,
        deliveryPostalCode,
        transactionList,
        contingencyAssignmentDocumentDate,
        consigneePhoneNumber,
        discountCodeSubCategoryId,
        discountCodeAuthorizerId,
        increasedPrice,
        uuid,
        yangoDelivery,
        freeOfChargeCategoryId,
        freeOfChargeSubCategoryId,
        freeOfChargeUserId,
        pinPadTransactions,
      };
      let url = PARCEL_ENDPOINT;

      if (authorization) {
        url = PARCEL_ENDPOINT_AUTHORIZATION;
      }
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      if (authorization) {
        const data = await handleResponse(
          response,
          (dataFromApi) => {
            if (!dataFromApi) return;

            const id =
              dataFromApi.id ||
              (dataFromApi.parcel && dataFromApi.parcel.id) ||
              (dataFromApi.data && dataFromApi.data.id) ||
              null;

            if (id) {
              dispatch(push(`${CARGO_PATH}/${id}`));
              dispatch(flagPrintCargoVoucher(true));
            }
          },
          dispatch,
          'post',
        );

        if (!data) return;
      } else {
        await isErrorResponse(response, null, dispatch);
      }

      const parcel = await response.json();

      dispatch(push(`${CARGO_PATH}/${parcel.id}`));
      dispatch(flagPrintCargoVoucher(true));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const getParcel =
  async ({ parcelId }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = `${PARCEL_ENDPOINT}/${parcelId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const parcel = await response.json();
      dispatch({
        type: GET_PARCEL,
        payload: parcel,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const clearParcel = () => (dispatch) =>
  dispatch({
    type: CLEAR_PARCEL,
  });

const postParcelRefund =
  async ({ parcelId }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = generatePostParcelRefund(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
      });

      await isErrorResponse(response, () => getParcel({ parcelId }), dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const postParcelRefundV2 =
  async (parcelId, refundValues) => async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = generatePostParcelRefundV2(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(refundValues),
      });

      await isErrorResponse(response, () => getParcel({ parcelId }), dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const postParcelVoid =
  async ({ parcelId }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = generatePostParcelVoid(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
      });

      await isErrorResponse(response, () => getParcel({ parcelId }), dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const getParcelPinPadTransactions = async (parcelId) => async () => {
  const url = generateParcelPinPadTransactionsEndpoint(parcelId);
  const response = await fetch(url, DEFAULT_GET_CONFIG);

  await isErrorResponse(response);

  return response.json();
};

const registerParcelPinPadVoid =
  async ({
    parcelId,
    originalTransactionId,
    operation,
    approved,
    responseCode,
    response: pinPadResponse,
  }) =>
  async () => {
    const url = generateRegisterParcelPinPadVoidEndpoint(parcelId);
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify({
        originalTransactionId,
        operation,
        approved,
        responseCode,
        response: pinPadResponse,
      }),
    });
    await isErrorResponse(response);
  };

const putParcelToPay =
  ({ parcelId, transactionList, pinPadTransactions }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingParcels(true));
      const url = generatePutParcelPay(parcelId);
      const payload = {
        transactionList,
        pinPadTransactions,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Entregado', 'Carga pagada correctamente');
      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagGettingParcels(false));
    }
  };

const fetchParcel = async (parcelId, dispatch) => {
  const urlGet = `${PARCEL_ENDPOINT}/${parcelId}`;
  const responseGet = await fetch(urlGet, DEFAULT_GET_CONFIG);
  await isErrorResponse(responseGet);
  const item = await responseGet.json();
  dispatch({
    type: GET_PARCEL,
    payload: item,
  });
};

const postParcelComment =
  ({ parcelId, description }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const payload = {
        parcelId,
        description,
      };
      const url = POST_PARCEL_COMMENT_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      await fetchParcel(parcelId, dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
    return null;
  };

const postParcelChangeSecretCode =
  ({ parcelId, secretCode }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingParcels(true));
      const url = generatePostParcelChangeCode(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify({ secretCode }),
      });
      await isErrorResponse(
        response,
        () => {
          toastr.success('Exito', 'Clave Secreta cambiada correctamente');
          return getParcel({ parcelId });
        },
        dispatch,
        'put',
      );
      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagGettingParcels(false));
    }
  };

const postCreditNoteParcel =
  ({
    parcelId,
    creditNoteAmount,
    creditNoteMotive,
    creditNoteMotiveDescription,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = generatePostCreditNoteParcel(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify({
          creditNoteAmount,
          creditNoteMotive,
          creditNoteMotiveDescription,
        }),
      });
      await isErrorResponse(
        response,
        () => {
          toastr.success('Exito', 'Nota de Crédito Creada');
          return getParcel({ parcelId });
        },
        dispatch,
        'put',
      );
      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const postParcelSendEmail =
  ({ parcelId, email }) =>
  async () => {
    try {
      const url = generatePostSendParcelByEmailEndpoint(parcelId);
      const payload = [email];
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response);
      toastr.success('Exito', 'Correo enviado correctamente');
    } catch (error) {
      toastr.error('Error', error.message);
    }
  };

const getParcelBySerieCorrelative =
  ({ serieCorrelative }) =>
  async (dispatch) => {
    try {
      const [serie, correlative] = serieCorrelative.split('-');
      const correlativeNumber = parseInt(correlative, 10);
      const url = generateGetParcelBySeriesAndCorrelative(
        serie,
        correlativeNumber,
      );
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response);
      const parcel = await response.json();
      dispatch(push(`${CARGO_PATH}/${parcel.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    }
  };

const postParcelVoidPaymentAuthorization =
  ({ parcelId, onAuthorized }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingParcels(true));
      const url = generatePostParcelVoidPaymentAuthorization(parcelId);
      const response = await fetch(url, DEFAULT_POST_CONFIG);
      await isErrorResponse(
        response,
        (authorization) => () => onAuthorized(authorization),
        dispatch,
        'post',
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingParcels(false));
    }
  };

const postParcelVoidPayment =
  ({ parcelId, operationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingParcels(true));
      const url = generatePostParcelVoidPayment(parcelId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify({ operationId }),
      });
      await isErrorResponse(
        response,
        () => getParcel({ parcelId }),
        dispatch,
        'post',
      );
      if (response.ok) {
        toastr.success(
          'Anulado',
          'Pago de la encomienda anulado correctamente',
        );
      }
      return response.ok;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagGettingParcels(false));
    }
  };

const postParcelChangeConsignee =
  ({ parcelId, consigneeCustomerId, secondaryConsigneeCustomerId }) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = generatePostParcelChangeConsigneeCustomer(parcelId);

      const payload = {
        consigneeCustomerId,
        secondaryConsigneeCustomerId,
      };
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(
        response,
        () => {
          toastr.success('Exito', 'Consignado cambiado correctamente');
          return getParcel({ parcelId });
        },
        dispatch,
      );
      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const putAcountingData =
  async (
    parcelId,
    {
      newBusinessName,
      newBusinessTaxId,
      businessId,
      comment,
      idDocumentNumber,
      isBusiness,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagParcelActivity(true));
      const url = `${PARCEL_ENDPOINT}/${parcelId}/accounting-information`;
      const payload = {
        newBusinessName,
        newBusinessTaxId,
        businessId,
        comment,
        newIdDocumentNumber: idDocumentNumber,
        isBusiness,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      await dispatch(getParcel({ parcelId }));
      toastr.success('Éxito', 'Datos contables actualizados correctamente');
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagParcelActivity(false));
    }
  };

const flagPostCargoPriceBaggage = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY,
    payload: flag,
  });

const clearCargoPriceBaggage = () => (dispatch) =>
  dispatch({
    type: CLEAR_CARGO_PRICE_BAGGAGE,
  });

const postCargoPriceBaggage = async (payload) => async (dispatch) => {
  try {
    dispatch(flagPostCargoPriceBaggage(true));
    const url = `${CARGO_PRICE_ENDPOINT}/baggage`;
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(payload),
    });
    await isErrorResponse(response, null, dispatch);
    const price = await response.json();
    dispatch({
      type: POST_CARGO_PRICE_BAGGAGE,
      payload: price,
    });
    return price;
  } catch (error) {
    toastr.error('Error', error.message);
    return null;
  } finally {
    dispatch(flagPostCargoPriceBaggage(false));
  }
};

export {
  clearCargoPrices,
  clearCargoPrice,
  postCargoPrice,
  postParcel,
  getParcels,
  getSalesSessionParcels,
  clearParcels,
  flagParcelActivity,
  getParcel,
  clearParcel,
  postParcelRefund,
  postParcelRefundV2,
  putParcelToPay,
  postParcelComment,
  postParcelChangeSecretCode,
  flagPrintCargoVoucher,
  postCreditNoteParcel,
  postParcelSendEmail,
  getParcelBySerieCorrelative,
  postParcelVoid,
  getParcelPinPadTransactions,
  registerParcelPinPadVoid,
  getSalesSessionOtherIncomesParcels,
  clearIncomesParcels,
  clearOtherIncomesParcels,
  postParcelVoidPayment,
  postParcelVoidPaymentAuthorization,
  postParcelChangeConsignee,
  putAcountingData,
  clearCargoPriceBaggage,
  postCargoPriceBaggage,
  flagPrintCargo,
};
